import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';
import { User } from '../../users/models/user.model';

export class ShipmentLabel extends Model {
  @Expose() createdAt: number;
  @Expose() deletedAt: number;
  @Expose() id: number;
  @Expose() isActive: boolean;
  @Expose() label: any;
  @Expose() comment: string;
  @Expose() createdBy: User;
}
